/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { FileSaverService } from 'ngx-filesaver';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { UtilityService } from '../utility_functions/utility_functions.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadFileLinkService {
  get downloadUrl(): any{
    return `${this.dataCollectorService.baseurl()}/misc/download`;
  }

  constructor(private dataCollectorService: DataCollectorService,
    private fileSaverService: FileSaverService,
    private toast: HotToastService, private utilityService: UtilityService) {
  }

  downloadFileFromLink(fileName: string, options: any): void {
    if (options) {
      const currentToast = this.toast.loading(`${this.utilityService.getLocaleValue('toast.downloading_file')} ` + fileName);
      this.dataCollectorService.downloadData(this.downloadUrl, options).subscribe((response: any) => {
        const buffer: any = new Uint8Array(response.body);
        const blob: any = new Blob([buffer], { type: response.headers.get('content-type') });
        this.fileSaverService.save(blob, fileName);
        currentToast.close();
      }, (error: any) => {
        currentToast.close();
        this.toast.error(error?.error?.message ?? fileName + ` ${this.utilityService.getLocaleValue('toast.downloading_failed')}`);
      });
    }
  }
}
